import { SignalsType } from '../model/types';
import { extractChild, extractParent } from './hierarchical-helper';

import * as d3Collection from 'd3-collection';

/**
 * This function generates categorical colors for flat and hierarchical data
 * using a function to generates those colors
 */
export const categoricalColors: (
  data: Array<any>,
  property: SignalsType,
  propertyCategory: string,
  colorGenerator: (key: string, categories: Array<string>, predefinedMap?: { [key: string]: string }) => { [key: string]: string },
  isHierarchical: boolean
) => { [key: string]: string } = (data, property, propertyCategory, colorGenerator, isHierarchical) => {
  if (!isHierarchical) {
    colorGenerator(property, getCategoriesFlatData(data, propertyCategory));
    return colorGenerator(property, getCategoriesFlatData(data, propertyCategory));
  }

  const categoryList = getCategoriesHierarchicalData(data, propertyCategory);
  const colorMapAncestors = colorGenerator(property, categoryList);

  const colorMapChildren = getChildrenCategoryList(getCategoriesFlatData(data, propertyCategory), colorMapAncestors);

  return colorGenerator(property, getCategoriesFlatData(data, propertyCategory), colorMapChildren);
};

const getCategoriesFlatData: (data: Array<any>, propertyCategory: string, childOnly?) => Array<string> = (
  data,
  propertyCategory,
  childOnly?
) =>
  d3Collection
    .nest()
    .key((d) => (childOnly ? extractChild(d[propertyCategory]) : d[propertyCategory]))
    .entries(data)
    .map((d) => d.key);

/**
 * the colors for hierarchical data are distributed where children inherit the color from their first ancestors
 */
const getCategoriesHierarchicalData: (data: Array<any>, propertyCategory: string) => Array<string> = (data, propertyCategory) =>
  d3Collection
    .nest()
    .key((d) => extractParent(d[propertyCategory]))
    .entries(data)
    .map((d) => d.key);

/**
 * Generate colors for children based on ancestors categories
 */

const getChildrenCategoryList: (categoryList: Array<string>, colorMapAncestors: { [key: string]: string }) => { [key: string]: string } = (
  categoryList,
  colorMapAncestors
) => {
  const childrenColorMap = {};

  categoryList.forEach((element) => {
    if (extractParent(element) !== extractChild(element)) {
      const ancestorColor = colorMapAncestors[extractParent(element)];
      //  we assigned to children the same color of their parent root
      childrenColorMap[element] = ancestorColor;
    }
  });

  return childrenColorMap;
};
